/*
  Carrousel des fiches riders / partenaires.

  Le defilement reste natif (scroll-snap) : les fleches et les pastilles ne font que
  piloter scrollLeft. Sans elles, sur ordinateur, la molette scrolle verticalement et
  l'utilisateur ne devine pas qu'il y a d'autres photos.
*/
(function () {
  function setup(root) {
    var track = root.querySelector('[data-bdrp-track]');
    var slides = root.querySelectorAll('[data-bdrp-slide]');
    if (!track || slides.length < 2) return;

    root.classList.add('bdrp__media--multiple');

    var prev = root.querySelector('[data-bdrp-prev]');
    var next = root.querySelector('[data-bdrp-next]');
    var dotsHost = root.querySelector('[data-bdrp-dots]');
    var dots = [];

    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bdrp__dot';
      dot.setAttribute('aria-label', 'Photo ' + (i + 1));
      dot.dataset.index = String(i);
      dotsHost.appendChild(dot);
      dots.push(dot);
    }

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(index) {
      var max = slides.length - 1;
      var target = Math.min(Math.max(index, 0), max);
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }

    function sync() {
      var index = current();
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', String(i === index));
      }
      prev.disabled = index <= 0;
      next.disabled = index >= slides.length - 1;
    }

    prev.addEventListener('click', function () { goTo(current() - 1); });
    next.addEventListener('click', function () { goTo(current() + 1); });
    dotsHost.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-index]');
      if (dot) goTo(Number(dot.dataset.index));
    });

    var ticking;
    track.addEventListener('scroll', function () {
      window.clearTimeout(ticking);
      ticking = window.setTimeout(sync, 80);
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-bdrp-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // L'editeur de theme reinjecte le HTML de la section sans recharger la page.
  document.addEventListener('shopify:section:load', init);
})();
